import { render, staticRenderFns } from "./fat-reduction.vue?vue&type=template&id=4d6e4874&scoped=true&"
import script from "./fat-reduction.vue?vue&type=script&lang=js&"
export * from "./fat-reduction.vue?vue&type=script&lang=js&"
import style0 from "./fat-reduction.vue?vue&type=style&index=0&id=4d6e4874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6e4874",
  null
  
)

export default component.exports